import { classifySessionError } from './classifySessionError';

export function resolveSessionLoadFailure<T>({
  error,
  cachedUser,
}: {
  error: unknown;
  cachedUser: T | null;
}): {
  clearSession: boolean;
  user: T | null;
  backendUnavailable: boolean;
} {
  if (classifySessionError(error) === 'unauthenticated') {
    return { clearSession: true, user: null, backendUnavailable: false };
  }

  return { clearSession: false, user: cachedUser, backendUnavailable: true };
}
